export enum ModulesEnum {
    AUTH    = "auth",
    USERS   = "users",
    ORDERS  = "orders"
}